import { create } from "zustand";
import type { VoicePath } from "../lib/voicePath";

/**
 * The latest "is my voice getting through?" reading for the live call,
 * written by `VoicePathMonitor` and read by the mic button's badge.
 * `level` updates several times a second for the popover's meter; `path`
 * every few seconds. Null outside a call.
 */
interface VoicePathState {
  path: VoicePath | null;
  level: number | null;
  setPath: (path: VoicePath) => void;
  setLevel: (level: number | null) => void;
  reset: () => void;
}

export const useVoicePathStore = create<VoicePathState>((set) => ({
  path: null,
  level: null,
  setPath: (path) => set({ path }),
  setLevel: (level) => set({ level }),
  reset: () => set({ path: null, level: null }),
}));
